// The Registrar type as a reader names it (docs/shape-ops-contract-codes.md
// §Decision 7): one of the six of UC50-15 by `registrars.kind.<code>`, anything
// else as it was stored, so a value that is not a type is shown rather than hidden.
import { knownRegistrarKind } from '@simsm/shared-types';

export function registrarKindLabel(t: (key: string) => string, kind: string): string {
  const known = knownRegistrarKind(kind);
  return known ? t(`registrars.kind.${known}`) : kind;
}
